import gql from 'graphql-tag';
import apollo from '@/library/http/apollo';
import Notify from 'quasar/src/plugins/Notify.js';;
import store from '@/store';
import HomePage from '@/pages/home/HomePage.vue';
import Services from '@/pages/services/Services.vue';
import Service from '@/pages/services/Service.vue';
import InfraService2 from '@/pages/infraService/InfraService2.vue';
import Templates from '@/pages/templates/Templates.vue';
import StandardsPage from '@/pages/standards/Standards.vue';
import DigitalService from '@/pages/digitalService/DigitalService.vue';
import ServiceStatus from '@/pages/serviceStatus/ServiceStatus.vue';
import Adrs from '@/pages/adrs/Adrs.vue';
import Adr from '@/pages/adrs/Adr.vue';
import NewInfraService from '@/pages/infraService/NewInfraService.vue';
import { getUserPermissions } from '@/pages/digitalService/api';
import Registration from '@/pages/registrations/Registration.vue';
import WorkFlows from '@/pages/workflows/WorkFlows.vue';
import WorkFlow from '@/pages/workflows/WorkFlow.vue';
import { getWorkflowById } from '@/pages/workflows/api';
import MyPortfolio from '@/pages/digitalServices/MyPortfolio.vue';
import NotFound from '@/pages/404/404.vue';
import RegistrationEnvironments from '@/pages/allItems/Environments.vue';
import CloudflareZones from '@/pages/allItems/Zones.vue';
import DnsRecords from '@/pages/allItems/DnsRecords.vue';
import FirewallRules from '@/pages/allItems/FirewallRules.vue';
import AdfRecords from '@/pages/allItems/AdfRecords.vue';
import Blueprints from '@/pages/administration/Blueprints.vue';
import Blueprint from '@/pages/administration/Blueprint.vue';
import AuthorizationSchemas from '@/pages/administration/AuthorizationSchemas.vue';
import AuthorizationSchema from '@/pages/administration/AuthSchema.vue';
import InfraServiceConfigs from '@/pages/administration/InfraServiceConfigs.vue';
import InfraServiceConfig from '@/pages/administration/InfraServiceConfig.vue';
import ServiceSchemas from '@/pages/administration/ServiceSchemas.vue';
import ServiceSchema from '@/pages/administration/ServiceSchema.vue';
import InfraServices from '@/pages/administration/InfraServices.vue';
import WorkflowForm from '@/pages/registrations/components/workflow-form/WorkflowForm.vue';

function notFoundLocation(to: any) {
  return {
    name: '404',
    params: { catchAll: to.path.substring(1).split('/').filter(Boolean) },
    query: to.query,
    replace: true,
  };
}

async function checkPermission(resourceName: string): Promise<boolean> {
  try {
    const response = await apollo.apolloClient.query({
      query: gql`
        query {
          whoAmI
        }
      `,
    });
    const email = response.data.whoAmI;
    const authData = {
      userEmail: email,
      scope: {},
      resource: {
        type: 'management',
        name: resourceName,
      },
    };
    return await getUserPermissions(authData);
  } catch (error: any) {
    Notify.create({
      type: 'negative',
      message: 'Permission check failed',
      position: 'bottom-right',
    });
    return false;
  }
}

const routes: Array<any> = [
  {
    path: '/',
    name: 'home',
    component: HomePage,
    meta: {
      beforeResolve: async (to: any, from: any, next: any) => {
        await store.dispatch('app/setPageTitle', 'Engineering Portal');
        return next();
      },
      layout: 'DefaultLayout',
    },
  },
  {
    path: '/workflows',
    name: 'workflows',
    component: WorkFlows,
    meta: {
      layout: 'SinglePageLayout',
      title: 'Workflows',
      beforeResolve: async (to: any, from: any, next: any) => {
        await store.dispatch('app/setPageTitle', 'Workflows');
        return next();
      },
    },
  },
  {
    path: '/workflows/:id',
    name: 'workflow',
    component: WorkFlow,
    meta: {
      layout: 'SinglePageLayout',
      title: 'Workflow',
      beforeResolve: async (to: any, from: any, next: any) => {
        try {
          const workflow = await getWorkflowById(to.params.id);
          if (!workflow) {
            return next(notFoundLocation(to));
          }
        } catch (error: any) {
          return next(notFoundLocation(to));
        }
        await store.dispatch('app/setPageTitle', 'Workflow Info');
        return next();
      },
    },
  },
  {
    path: '/standards',
    name: 'standards',
    component: StandardsPage,
    meta: {
      beforeResolve: async (to: any, from: any, next: any) => {
        await store.dispatch('app/setPageTitle', 'Relevant Standards');
        return next();
      },
      layout: 'SinglePageLayout',
      title: 'Relevant Standards',
      breadcrumbs: [
        {
          text: 'Home',
          to: '/',
        },
        {
          text: 'Relevant Standards',
        },
      ],
    },
  },
  {
    path: '/services',
    name: 'services',
    component: Services,
    meta: {
      beforeResolve: async (to: any, from: any, next: any) => {
        await store.dispatch('app/setPageTitle', 'Service catalog');
        return next();
      },
      layout: 'CatalogLayout',
      title: 'Service Catalog',
      breadcrumbs: [
        {
          text: 'Home',
          to: '/',
        },
        {
          text: 'Service Catalog',
        },
      ],
    },
  },
  {
    path: '/my-portfolio',
    name: 'digitalServices',
    component: MyPortfolio,
    meta: {
      beforeResolve: async (to: any, from: any, next: any) => {
        await store.dispatch('app/setPageTitle', 'My portfolio');
        return next();
      },
      layout: 'MyPortfolioLayout',
      title: 'Digital Services',
      breadcrumbs: [
        {
          text: 'Home',
          to: '/',
        },
        {
          text: 'My Portfolio',
        },
      ],
    },
  },
  {
    path: '/my-portfolio/:dsId/registration/:regId',
    name: 'registration',
    component: Registration,
    meta: {
      beforeResolve: async (to: any, from: any, next: any) => {
        //await store.dispatch('app/setPageTitle', `${to.params.isId} registration on ${to.params.dsId}`);
        return next();
      },
      layout: 'DigitalServiceLayout',
    },
  },
  {
    path: '/my-portfolio/:id',
    name: 'digitalService',
    component: DigitalService,
    meta: {
      beforeResolve: async (to: any, from: any, next: any) => {
        try {
          const response = await apollo.apolloClient.query({
            query: gql`
              query {
                getApplicationByAPMID(digitalServiceAPMID: "${to.params.id.toUpperCase()}") {
                  apmId
                  digitalServiceName
                }
              }
            `,
          });
          const application = response.data.getApplicationByAPMID;
          if (!application) {
            return next(notFoundLocation(to));
          }
          await store.dispatch('app/setPageTitle', application.digitalServiceName || application.apmId);
        } catch (error) {
          return next(notFoundLocation(to));
        }
        return next();
      },
      layout: 'DigitalServiceLayout',
      breadcrumbs: [
        {
          text: 'Home',
          to: '/',
        },
        {
          to: '/my-portfolio',
          text: 'My Digital Services',
        },
      ],
    },
  },
  {
    path: '/services/category/:id',
    name: 'service',
    component: Service,
    meta: {
      beforeResolve: async (to: any, from: any, next: any) => {
        try {
          const response = await apollo.apolloClient.query({
            query: gql`
            query {
              categoryServicesById(category: "${to.params.id}") {
                name
              }
            }
          `,
          });
          const service = response.data.categoryServicesById;
          if (!service) {
            return next(notFoundLocation(to));
          }
          await store.dispatch('app/setPageTitle', service.name);
        } catch (error) {
          return next(notFoundLocation(to));
        }
        return next();
      },
      layout: 'ServiceLayout',
      breadcrumbs: [
        {
          text: 'Home',
          to: '/',
        },
        {
          to: '/services',
          text: 'Service Catalog',
        },
      ],
    },
  },
  {
    path: '/services/:id',
    name: 'infraService',
    component: InfraService2,
    meta: {
      beforeResolve: async (to: any, from: any, next: any) => {
        try {
          const response = await apollo.apolloClient.query({
            query: gql`
            query {
              infraServiceById(id: "${to.params.id}") {
                displayName
                serviceName
                apmid
                owners
              }
            }
          `,
          });
          const service = response.data.infraServiceById;
          if (!service) {
            return next(notFoundLocation(to));
          }
          const userInfo = store.getters['app/userInfo'];
          if (userInfo?.applicationsInOwn) {
            const isOwner = userInfo.applicationsInOwn.find((app: any) => app.apmId === service.apmid);
            await store.dispatch('app/setServiceOwnership', !!isOwner);
          }
          await store.dispatch('app/setPageTitle', service.displayName || service.serviceName);
        } catch (error) {
          return next(notFoundLocation(to));
        }
        return next();
      },
      layout: 'SingeServiceLayout',
      infraService: true,
      title: 'Single Service Page',
      breadcrumbs: [
        {
          text: 'Home',
          to: '/',
        },
        {
          text: 'Service Catalog',
          to: '/services',
        },
      ],
    },
  },
  {
    path: '/services/new',
    name: 'newInfraService',
    component: NewInfraService,
    meta: {
      beforeResolve: async (to: any, from: any, next: any) => {
        let isAuth = false;
        if (!to.params?.category) {
          await store.dispatch('app/setPageTitle', 'Create New Infrastructure Service');
          isAuth = await checkPermission('service.catalog.manage');
        } else {
          isAuth = true;
        }
        if (isAuth) {
          return next();
        }
        return next('/');
      },
      layout: 'NewInfraStructureServiceLayout',
      infraService: true,
      title: 'Create New Infrastructure Service',
      breadcrumbs: [
        {
          text: 'Home',
          to: '/',
        },
        {
          text: 'Service Catalog',
          to: '/services',
        },
      ],
    },
  },
  {
    path: '/templates',
    name: 'templates',
    component: Templates,
    meta: {
      beforeResolve: async (to: any, from: any, next: any) => {
        await store.dispatch('app/setPageTitle', 'Templates');
        return next();
      },
      layout: 'TemplatesLayout',
      title: 'Templates',
      breadcrumbs: [
        {
          text: 'Home',
          to: '/',
        },
        {
          text: 'Templates',
        },
      ],
    },
  },
  {
    path: '/service-status',
    name: 'serviceStatus',
    component: ServiceStatus,
    meta: {
      beforeResolve: async (to: any, from: any, next: any) => {
        await store.dispatch('app/setPageTitle', 'Service Status');
        return next();
      },
      layout: 'ServiceStatusLayout',
      title: 'Service Status',
      breadcrumbs: [
        {
          text: 'Home',
          to: '/',
        },
        {
          text: 'Service Status',
        },
      ],
    },
  },
  {
    path: '/adrs',
    name: 'adrs',
    component: Adrs,
    meta: {
      beforeResolve: async (to: any, from: any, next: any) => {
        await store.dispatch('app/setPageTitle', 'ADRs');
        return next();
      },
      layout: 'AdrsLayout',
      title: 'ADRs',
      breadcrumbs: [
        {
          text: 'Home',
          to: '/',
        },
        {
          text: 'ADRs',
        },
      ],
    },
  },
  {
    path: '/adrs/:id',
    name: 'adr',
    component: Adr,
    meta: {
      beforeResolve: async (to: any, from: any, next: any) => {
        try {
          const response = await apollo.apolloClient.query({
            query: gql`
            query {
              getADRs(filter: {filterBy: {adrId: "${to.params.id}"}, includeFields: {}}) {
                adrs {
                  name
                }
              }
            }
          `,
          });
          const adr = response.data.getADRs?.adrs;
          if (!adr || !adr.length) {
            return next(notFoundLocation(to));
          }
          await store.dispatch('app/setPageTitle', adr[0].name);
        } catch (error) {
          return next(notFoundLocation(to));
        }
        return next();
      },
      layout: 'SinglePageLayout',
      breadcrumbs: [
        {
          text: 'Home',
          to: '/',
        },
        {
          to: '/adrs',
          text: 'ADRs',
        },
      ],
    },
  },
  {
    path: '/registration-environments',
    name: 'registrationEnvironments',
    component: RegistrationEnvironments,
    meta: {
      beforeResolve: async (to: any, from: any, next: any) => {
        await store.dispatch('app/setPageTitle', 'Registration Environments');
        return next();
      },
      layout: 'DigitalServiceLayout',
      title: 'Registration Environments',
      breadcrumbs: [
        {
          text: 'Home',
          to: '/',
        },
        {
          text: 'Registration Environments',
        },
      ],
    },
  },
  {
    path: '/cloudflare-zones',
    name: 'cloudflareZones',
    component: CloudflareZones,
    meta: {
      beforeResolve: async (to: any, from: any, next: any) => {
        await store.dispatch('app/setPageTitle', 'Cloudflare Zones');
        return next();
      },
      layout: 'DigitalServiceLayout',
      title: 'Cloudflare Zones',
      breadcrumbs: [
        {
          text: 'Home',
          to: '/',
        },
        {
          text: 'Cloudflare Zones',
        },
      ],
    },
  },
  {
    path: '/firewall-rules',
    name: 'firewallRules',
    component: FirewallRules,
    meta: {
      beforeResolve: async (to: any, from: any, next: any) => {
        await store.dispatch('app/setPageTitle', 'Firewall Rule (EAR) Requests');
        return next();
      },
      layout: 'DigitalServiceLayout',
      title: 'Firewall Rule (EAR) Requests',
      breadcrumbs: [
        {
          text: 'Home',
          to: '/',
        },
        {
          text: 'Firewall Rule (EAR) Requests',
        },
      ],
    },
  },
  {
    path: '/dns-records',
    name: 'dnsRecords',
    component: DnsRecords,
    meta: {
      beforeResolve: async (to: any, from: any, next: any) => {
        await store.dispatch('app/setPageTitle', 'Dns Records');
        return next();
      },
      layout: 'DigitalServiceLayout',
      title: 'Dns Records',
      breadcrumbs: [
        {
          text: 'Home',
          to: '/',
        },
        {
          text: 'Dns Records',
        },
      ],
    },
  },
  {
    path: '/adf-records',
    name: 'adfRecords',
    component: AdfRecords,
    meta: {
      beforeResolve: async (to: any, from: any, next: any) => {
        await store.dispatch('app/setPageTitle', 'ADF Records');
        return next();
      },
      layout: 'DigitalServiceLayout',
      title: 'ADF Records',
      breadcrumbs: [
        {
          text: 'Home',
          to: '/',
        },
        {
          text: 'ADF Records',
        },
      ],
    },
  },
  {
    path: '/blueprints',
    name: 'blueprints',
    component: Blueprints,
    meta: {
      beforeResolve: async (to: any, from: any, next: any) => {
        await store.dispatch('app/setPageTitle', 'Blueprints');
        const isAuth = await checkPermission('admin.manage');
        if (isAuth) {
          return next();
        }
        return next('/');
      },
      layout: 'DigitalServiceLayout',
      title: 'Blueprints',
      breadcrumbs: [
        {
          text: 'Home',
          to: '/',
        },
        {
          text: 'Blueprints',
        },
      ],
    },
  },
  {
    path: '/blueprints/new',
    name: 'newBlueprint',
    component: Blueprint,
    meta: {
      beforeResolve: async (to: any, from: any, next: any) => {
        await store.dispatch('app/setPageTitle', 'New Blueprint');
        const isAuth = await checkPermission('admin.manage');
        if (isAuth) {
          return next();
        }
        return next('/');
      },
      layout: 'DigitalServiceLayout',
      title: 'New Blueprint',
      breadcrumbs: [
        {
          text: 'Home',
          to: '/',
        },
        {
          text: 'Blueprints',
          to: '/blueprints',
        },
        {
          text: 'New Blueprint',
        },
      ],
    },
  },
  {
    path: '/blueprints/:id',
    name: 'editBlueprint',
    component: Blueprint,
    meta: {
      beforeResolve: async (to: any, from: any, next: any) => {
        await store.dispatch('app/setPageTitle', `Edit blueprint`);
        const isAuth = await checkPermission('admin.manage');
        if (isAuth) {
          return next();
        }
        return next('/');
      },
      layout: 'DigitalServiceLayout',
      title: 'Edit Blueprint',
      breadcrumbs: [
        {
          text: 'Home',
          to: '/',
        },
        {
          text: 'Blueprints',
          to: '/blueprints',
        },
        {
          text: 'Edit Blueprint',
        },
      ],
    },
  },
  {
    path: '/authorization-schemas',
    name: 'authorizationSchemas',
    component: AuthorizationSchemas,
    meta: {
      beforeResolve: async (to: any, from: any, next: any) => {
        await store.dispatch('app/setPageTitle', 'Authorization Schemas');
        const isAuth = await checkPermission('admin.manage');
        if (isAuth) {
          return next();
        }
        return next('/');
      },
      layout: 'DigitalServiceLayout',
      title: 'Authorization Schemas',
      breadcrumbs: [
        {
          text: 'Home',
          to: '/',
        },
        {
          text: 'Authorization Schemas',
        },
      ],
    },
  },
  {
    path: '/authorization-schemas/new',
    name: 'newAuthorizationSchema',
    component: AuthorizationSchema,
    meta: {
      beforeResolve: async (to: any, from: any, next: any) => {
        await store.dispatch('app/setPageTitle', 'New Authorization Schema');
        const isAuth = await checkPermission('admin.manage');
        if (isAuth) {
          return next();
        }
        return next('/');
      },
      layout: 'DigitalServiceLayout',
      title: 'New Authorization Schema',
      breadcrumbs: [
        {
          text: 'Home',
          to: '/',
        },
        {
          text: 'Authorization Schemas',
          to: '/authorization-schemas',
        },
        {
          text: 'New Authorization Schema',
        },
      ],
    },
  },
  {
    path: '/authorization-schemas/:id',
    name: 'editAuthorizationSchema',
    component: AuthorizationSchema,
    meta: {
      beforeResolve: async (to: any, from: any, next: any) => {
        await store.dispatch('app/setPageTitle', `Edit authorization schema`);
        const isAuth = await checkPermission('admin.manage');
        if (isAuth) {
          return next();
        }
        return next('/');
      },
      layout: 'DigitalServiceLayout',
      title: 'Edit Authorization Schema',
      breadcrumbs: [
        {
          text: 'Home',
          to: '/',
        },
        {
          text: 'Authorization Schemas',
          to: '/authorization-schemas',
        },
        {
          text: 'Edit Authorization Schema',
        },
      ],
    },
  },
  {
    path: '/infra-service-configs',
    name: 'infraServiceConfigs',
    component: InfraServiceConfigs,
    meta: {
      beforeResolve: async (to: any, from: any, next: any) => {
        await store.dispatch('app/setPageTitle', 'Infra Service Configs');
        const isAuth = await checkPermission('admin.manage');
        if (isAuth) {
          return next();
        }
        return next('/');
      },
      layout: 'DigitalServiceLayout',
      title: 'Infra Service Configs',
      breadcrumbs: [
        {
          text: 'Home',
          to: '/',
        },
        {
          text: 'Infra Service Configs',
        },
      ],
    },
  },
  {
    path: '/infra-service-configs/new',
    name: 'newInfraServiceConfig',
    component: InfraServiceConfig,
    meta: {
      beforeResolve: async (to: any, from: any, next: any) => {
        await store.dispatch('app/setPageTitle', 'New Infra Service Config');
        const isAuth = await checkPermission('admin.manage');
        if (isAuth) {
          return next();
        }
        return next('/');
      },
      layout: 'DigitalServiceLayout',
      title: 'New Infra Service Config',
      breadcrumbs: [
        {
          text: 'Home',
          to: '/',
        },
        {
          text: 'Infra Service Configs',
          to: '/infra-service-configs',
        },
        {
          text: 'New Infra Service Config',
        },
      ],
    },
  },
  {
    path: '/infra-service-configs/:id',
    name: 'editInfraServiceConfig',
    component: InfraServiceConfig,
    meta: {
      beforeResolve: async (to: any, from: any, next: any) => {
        await store.dispatch('app/setPageTitle', `Edit infra service config`);
        const isAuth = await checkPermission('admin.manage');
        if (isAuth) {
          return next();
        }
        return next('/');
      },
      layout: 'DigitalServiceLayout',
      title: 'Edit Infra Service Config',
      breadcrumbs: [
        {
          text: 'Home',
          to: '/',
        },
        {
          text: 'Infra Service Configs',
          to: '/infra-service-configs',
        },
        {
          text: 'Edit Infra Service Config',
        },
      ],
    },
  },
  {
    path: '/service-schemas',
    name: 'serviceSchemas',
    component: ServiceSchemas,
    meta: {
      beforeResolve: async (to: any, from: any, next: any) => {
        await store.dispatch('app/setPageTitle', 'Service Schemas');
        const isAuth = await checkPermission('admin.manage');
        if (isAuth) {
          return next();
        }
        return next('/');
      },
      layout: 'DigitalServiceLayout',
      title: 'Service Schemas',
      breadcrumbs: [
        {
          text: 'Home',
          to: '/',
        },
        {
          text: 'Service Schemas',
        },
      ],
    },
  },
  {
    path: '/service-schemas/:id',
    name: 'editServiceSchema',
    component: ServiceSchema,
    meta: {
      beforeResolve: async (to: any, from: any, next: any) => {
        await store.dispatch('app/setPageTitle', `Edit service schema`);
        const isAuth = await checkPermission('admin.manage');
        if (isAuth) {
          return next();
        }
        return next('/');
      },
      layout: 'DigitalServiceLayout',
      title: 'Edit Service Schema',
      breadcrumbs: [
        {
          text: 'Home',
          to: '/',
        },
        {
          text: 'Service Schemas',
          to: '/service-schemas',
        },
        {
          text: 'Edit Service Schema',
        },
      ],
    },
  },
  {
    path: '/service-schemas/new',
    name: 'newServiceSchema',
    component: ServiceSchema,
    meta: {
      beforeResolve: async (to: any, from: any, next: any) => {
        await store.dispatch('app/setPageTitle', 'New Service Schema');
        const isAuth = await checkPermission('admin.manage');
        if (isAuth) {
          return next();
        }
        return next('/');
      },
      layout: 'DigitalServiceLayout',
      title: 'New Service Schema',
      breadcrumbs: [
        {
          text: 'Home',
          to: '/',
        },
        {
          text: 'Service Schemas',
          to: '/service-schemas',
        },
        {
          text: 'New Service Schema',
        },
      ],
    },
  },
  {
    path: '/infra-services',
    name: 'infraServices',
    component: InfraServices,
    meta: {
      beforeResolve: async (to: any, from: any, next: any) => {
        await store.dispatch('app/setPageTitle', 'Infra Services');
        const isAuth = await checkPermission('admin.manage');
        if (isAuth) {
          return next();
        }
        return next('/');
      },
      layout: 'DigitalServiceLayout',
      title: 'Infra Services',
      breadcrumbs: [
        {
          text: 'Home',
          to: '/',
        },
        {
          text: 'Infra Services',
        },
      ],
    },
  },
  {
    path: '/workflow-form/:apmId/:registrationId',
    name: 'workflow-form',
    component: WorkflowForm,
    meta: {
      beforeResolve: async (to: any, from: any, next: any) => {
        await store.dispatch('app/setPageTitle', 'Workflow Form');
        return next();
      },
      layout: 'DefaultLayout',
      title: 'Workflow Form',
    },
  },
  {
    path: '/:catchAll(.*)*',
    name: '404',
    meta: {
      beforeResolve: async (to: any, from: any, next: any) => {
        await store.dispatch('app/setPageTitle', 'Error 404');
        return next();
      },
      layout: 'SinglePageLayout',
      title: 'Not Found',
    },
    component: NotFound,
  },
];

export default routes;
